export const isBrowser: boolean = typeof window !== 'undefined';
export default isBrowser;
